"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSubject = void 0;
const subject_def_1 = require("./subject-def");
const makeSubject = (object, options) => (subject_def_1.ObjectSubjectDef.makeForInstance(object, options));
exports.makeSubject = makeSubject;
//# sourceMappingURL=make-subject.js.map